import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { debounce } from 'lodash';
import './styles.scss';

const BackNextToggle = ({
    shiftBack, shiftNext, canProceed, canDecrease
}) => {
    const handleClickNext = debounce(shiftNext, 300);
    const handleClickBack = debounce(shiftBack, 300);

    return (
        <div className='toggle-container'>
            <button
                disabled={ !canDecrease }
                onClick={ () => handleClickBack() }>
                <i className='fa fa-chevron-left' />
                <span>{i18n.t('engagement.back')}</span>
                <div className='placeholder' />
            </button>
            <button
                disabled={ !canProceed }
                className='next-button'
                onClick={ () => handleClickNext() }>
                <div className='placeholder' />
                <span>{i18n.t('engagement.next')}</span>
                <i className='fa fa-chevron-right' />
            </button>
        </div>
    );
};

BackNextToggle.propTypes = {
    shiftBack: PropTypes.func,
    shiftNext: PropTypes.func,
    canProceed: PropTypes.bool,
    canDecrease: PropTypes.bool
};

BackNextToggle.defaultProps = {
    shiftBack: null,
    shiftNext: null,
    canProceed: false,
    canDecrease: false
};

export default BackNextToggle;
